import { z } from 'zod';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
export const mechanicPirateStateSchema = z.object({
    locationTileIndex: z.number().int().nonnegative(),
    isActive: z.boolean()
}).strict();
export function validateMechanicPirateState(data) {
    return validateState(mechanicPirateStateSchema, data);
}
export const mechanicPirateStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicPirateStateSchema);
